import { useCalendarStore } from '../../stores/calendar'
import { useDocketStore } from '../../stores/docket'
import { useSettingsStore } from '../../stores/settings'
import { useWritingLogStore } from '../../stores/writingLog'
import { planPrepTasks } from '../../utils/prepTasks'

/**
 * Makes, moves, and removes events' prep tasks to match the events (see
 * utils/prepTasks). Run after calendar events change, here or on another
 * device. Nothing happens while the Calendar (and its tasks) is switched off.
 */
export function syncPrepTasks() {
  const settings = useSettingsStore()
  if (settings.toolPrefs.hidden.includes('calendar')) return
  const docket = useDocketStore()
  // New tasks go to the list Settings > Calendar names, while it still exists.
  const wanted = settings.calendarPrefs.prep.listId
  const listId = wanted && docket.findList(wanted) ? wanted : null
  const { save, remove } = planPrepTasks(useCalendarStore().events, docket.tasks, useWritingLogStore().today, Date.now(), listId)
  for (const id of remove) docket.removeTask(id)
  for (const task of save) docket.saveTask(task)
}
